import { validateFileExtension } from './validateFileExtension'

export function uploadFile({ file, s3_file_key, onProgress }) {
  let xhr

  const uploadPromise = new Promise(async (resolve, reject) => {
    const filename = encodeURIComponent(file.name)

    if (!validateFileExtension(filename)) {
      console.error('Invalid file extension')
      reject(new Error('Invalid file extension'))
      return
    }

    const contentType = file.type

    try {
      const response = await fetch('/api/presigned-upload-url', {
        method: 'POST',
        body: JSON.stringify({ filename: s3_file_key, contentType }),
        headers: {
          'Content-Type': 'application/json',
        },
      })

      const { signedUrl } = await response.json()

      xhr = new XMLHttpRequest()

      xhr.open('PUT', signedUrl, true)
      xhr.setRequestHeader('Content-Type', contentType)

      xhr.upload.addEventListener('progress', function (e) {
        if (e.lengthComputable) {
          const percentComplete = (e.loaded / e.total) * 100
          onProgress(percentComplete)
        }
      })

      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          console.log('File uploaded successfully')
          resolve(s3_file_key)
        } else {
          reject(new Error('Error uploading file'))
        }
      }

      xhr.onerror = function () {
        reject(new Error('Error uploading file'))
      }

      xhr.onabort = function () {
        reject(new Error('Upload cancelled'))
      }

      xhr.send(file)
    } catch (error) {
      reject(error)
    }
  })

  return {
    promise: uploadPromise,
    cancel: () => {
      if (xhr) {
        xhr.abort()
      }
    },
  }
}
